import React from 'react'

import { translate } from '~/core/translate'
import Modal from '~/components/common/modal'
import { getPriceString } from '../../core/utils'
import {
  StyledCloseLargeIcon,
  Container,
  TitleContainer,
  Title,
  BillToContainer,
  BillToLabel,
  BillToInfoLabel,
  UnpaidInvoicesLabel,
  InvoiceRow,
  LabelInvoiceId,
  ViewInvoiceDetailsLink,
  TotalAmountLabel,
  LabelAmountDue,
  LabelAmount,
  TotalAmountDueContainer
} from './styled'

const BillingDetailsDialog = ({ invoices, userInfo, onClose }) => {
  const totalAmount = invoices.reduce((acc, inv) => acc + inv.amount, 0) / 100
  const currency = invoices[0].currency

  const openInvoicePdf = invoice => window.open(invoice.pdfLink)

  return (
    <Modal
      size='small'
      visible width='600px'
      height='auto'
      onClose={onClose}
    >
      <Container>
        <TitleContainer>
          <Title>{translate('bill_details')}</Title>
          <StyledCloseLargeIcon onClick={onClose} />
        </TitleContainer>
        <BillToContainer>
          <BillToLabel>{translate('bill_to')}</BillToLabel>
          {userInfo.fullName && <BillToInfoLabel>{userInfo.fullName}</BillToInfoLabel>}
          <BillToInfoLabel>{userInfo.email}</BillToInfoLabel>
        </BillToContainer>
        <UnpaidInvoicesLabel>{translate('your_unpaid_invoices')}</UnpaidInvoicesLabel>
        {invoices.map(inv => (
          <InvoiceRow key={inv.id}>
            <LabelInvoiceId>{`${translate('invoice')}: ${inv.invoiceNumber || inv.status}`}</LabelInvoiceId>
            {inv.pdfLink && <ViewInvoiceDetailsLink onClick={() => openInvoicePdf(inv)}>{translate('view')}</ViewInvoiceDetailsLink>}
            <LabelAmountDue>{translate('amount_due')}</LabelAmountDue>
            <LabelAmount>{getPriceString(inv.currency, inv.amount / 100)}</LabelAmount>
          </InvoiceRow>
        ))}
        <TotalAmountDueContainer>
          <TotalAmountLabel>{translate('total_amount_due')}</TotalAmountLabel>
          <LabelAmount>{getPriceString(currency, totalAmount)}</LabelAmount>
        </TotalAmountDueContainer>
      </Container>
    </Modal>
  )
}

export default BillingDetailsDialog
